<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-4 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-yellow-50 p-3 border-1 border-yellow-100 border-round-lg">
            <i class="pi pi-calendar-minus text-yellow-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <div *ngIf="activeTab() === 'preview'" class="p-4 overflow-auto h-full">
      <div class="flex flex-column gap-4">
         <div class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
               <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-calendar text-blue-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.PREVIEW.WAIT_DAYS_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-blue-800">
                     {{ waitDays() ?? 0 }}
                     {{
                        (waitDays() ?? 0) === 1
                           ? ('DATA.COMMON.TIME.DAY' | translate)
                           : ('DATA.COMMON.TIME.DAYS' | translate)
                     }}
                  </span>
               </div>
            </div>
         </div>

         <div class="surface-card p-4 border-1 border-round-xl border-indigo-100 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
               <div class="bg-indigo-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i
                     class="pi text-indigo-700 text-lg"
                     [ngClass]="antesODespues() === 'BEFORE' ? 'pi-arrow-left' : 'pi-arrow-right'"
                  ></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.PREVIEW.DIRECTION_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-indigo-800">
                     {{
                        antesODespues() === 'beforeDueDate'
                           ? ('DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.PREVIEW.BEFORE' | translate)
                           : ('DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.PREVIEW.AFTER' | translate)
                     }}
                  </span>
               </div>
            </div>
         </div>

         <div class="surface-card p-4 border-1 border-round-xl border-teal-100 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
               <div class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-sun text-teal-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.PREVIEW.TIME_OF_DAY_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-teal-800">
                     {{
                        partDay() === 'MORNING'
                           ? ('DATA.COMMON.TIME_OF_WEEK.MORNING' | translate)
                           : partDay() === 'EVENING'
                             ? ('DATA.COMMON.TIME_OF_WEEK.EVENING' | translate)
                             : partDay() === 'FULL_DAY'
                               ? ('DATA.COMMON.TIME_OF_WEEK.FULL_DAY' | translate)
                               : '-'
                     }}
                  </span>
               </div>
            </div>
         </div>

         <p-messages severity="info" [closable]="true">
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2">
                  <span class="pi pi-info-circle p-1"></span>
                  <span [innerHTML]="getSummaryMessage()"></span>
               </div>
            </ng-template>
         </p-messages>

         <p-divider class="w-full"></p-divider>

         <app-regional-config-info
            [collectorIds]="campaignSelected()?.collectorIds || []"
            [campaignType]="campaignSelected()?.type"
         >
         </app-regional-config-info>

         <div *ngIf="errors().length" class="flex flex-column gap-2">
            <p-messages severity="error" [closable]="false">
               <ng-template pTemplate>
                  <div class="flex flex-column gap-2 w-full">
                     <div *ngFor="let error of errors()" class="text-sm">
                        {{ error.errorMessage }}
                     </div>
                  </div>
               </ng-template>
            </p-messages>
         </div>
      </div>
   </div>

   <div *ngIf="activeTab() === 'config'" class="p-4 overflow-auto h-full">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.WAIT_DAYS_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.WAIT_DAYS_HELP' | translate
               }}</span>
            </div>

            <p-inputNumber
               [ngModel]="waitDays()"
               (ngModelChange)="onWaitDaysChange($event)"
               [min]="0"
               [useGrouping]="false"
               [showButtons]="true"
               buttonLayout="horizontal"
               class="w-full"
               styleClass="w-full"
               [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.WAIT_DAYS_PLACEHOLDER' | translate"
            ></p-inputNumber>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.DIRECTION_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.DIRECTION_HELP' | translate
               }}</span>
            </div>

            <div class="flex flex-row gap-5 mt-2">
               <div class="flex align-items-center gap-2">
                  <p-radioButton
                     name="directionGroup"
                     value="beforeDueDate"
                     [ngModel]="antesODespues()"
                     (ngModelChange)="onDirectionChange($event)"
                     inputId="dir-before"
                  >
                  </p-radioButton>
                  <label for="dir-before" class="cursor-pointer text-800 font-medium select-none">
                     {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.DIRECTION_BEFORE' | translate }}
                  </label>
               </div>

               <div class="flex align-items-center gap-2">
                  <p-radioButton
                     name="directionGroup"
                     value="afterDueDate"
                     [ngModel]="antesODespues()"
                     (ngModelChange)="onDirectionChange($event)"
                     inputId="dir-after"
                  >
                  </p-radioButton>
                  <label for="dir-after" class="cursor-pointer text-800 font-medium select-none">
                     {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.DIRECTION_AFTER' | translate }}
                  </label>
               </div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.PART_DAY_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.PART_DAY_HELP' | translate
               }}</span>
            </div>

            <p-dropdown
               [options]="partDayOptions()"
               [ngModel]="partDay()"
               (ngModelChange)="onPartDayChange($event)"
               optionLabel="label"
               optionValue="value"
               styleClass="w-full"
               class="w-full"
               [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAYS_FOR_DUE_DATE.CONFIG.PART_DAY_PLACEHOLDER' | translate"
            ></p-dropdown>
         </div>

         <p-divider class="w-full"></p-divider>

         <app-regional-config-info
            [collectorIds]="campaignSelected()?.collectorIds || []"
            [campaignType]="campaignSelected()?.type"
         >
         </app-regional-config-info>

         <div *ngIf="errors().length" class="flex flex-column gap-2 mt-2">
            <p-messages severity="error" [closable]="false">
               <ng-template pTemplate>
                  <div class="flex flex-column gap-2 w-full">
                     <div *ngFor="let error of errors()" class="text-sm">
                        {{ error.errorMessage }}
                     </div>
                  </div>
               </ng-template>
            </p-messages>
         </div>
      </div>
   </div>
</div>
